import { GameItemSize } from './styled';

export const defaultGameSizesConfig: GameSizeConfig = {
  desktopL: GameItemSize.L,
  desktop: GameItemSize.M,
  tablet: GameItemSize.M,
  mobile: GameItemSize.M,
  mobileS: GameItemSize.S,
};

export interface GameSizeConfig {
  desktopL: GameItemSize;
  desktop: GameItemSize;
  tablet: GameItemSize;
  mobile: GameItemSize;
  mobileS: GameItemSize;
}
